<template>
  <div id="memberForm">
    <common-member-form :from="'memberForm'"/>
  </div>
</template>

<script>
import CommonMemberForm from '../common/CommonMemberForm.vue'

export default {
  components: { CommonMemberForm }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/MemberForm.vue